let stepsCount = $(".quiz__step").length
let activeStep = getCurrentStepNum()

setStepsProgress()

function setStepsProgress() {
    $(".quiz__progress-fill").css("width",`${activeStep/stepsCount*100}%`)
}

function getCurrentStepNum() {
    return +$(".quiz__step._active").attr("data-step")
}


$(".quiz__next").click(function () {
    if(activeStep===stepsCount){
        return
    }
    if(activeStep===stepsCount-1){
        $(".quiz__nav").addClass("_hidden")
    }
    setActiveStep(activeStep+1)
    $(".quiz__prev").removeClass("_hidden")
    $(".quiz__next").addClass("_disabled")
})

$(".quiz__prev").click(function () {
    if(activeStep===1){
        return
    }
    if(activeStep===2){
        $(".quiz__prev").addClass("_hidden")
    }
    setActiveStep(activeStep-1)
})


function setActiveStep(num) {
    $(".quiz__step").removeClass("_active")
    $(`.quiz__step[data-step="${num}"]`).addClass("_active")
    activeStep = getCurrentStepNum()
    setStepsProgress()
}

$(".quiz__radio input").change(function () {
    $(".quiz__next").removeClass("_disabled")
})

$(".quiz__select select").change(function () {
    $(".quiz__next").removeClass("_disabled")
})
